<template>
  <div>
    <div style="display: block;margin-top: 90px" >
      <img src="../assets/images/contact.png"  width="100%" />
    </div>
    <!-- ##### Contact Area Start ##### -->
    <section class="contact-area" style="margin-top: 50px">

        <el-row type="flex" justify="space-around" style="margin-left: 20%;margin-bottom: 50px;margin-right: 50px" >

          <!-- Contact Content -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="contact-content mb-100" style="width:80%; text-align: left">
              <!-- Section Heading -->
              <div class="section-heading">
                <p>Contact now</p>
                <h2><span>联 系</span> 我 们</h2>
                <img src="../assets/images/decor.png" alt="">
              </div>
              <!-- Contact Form Area -->
              <div class="contact-form-area">
                <el-form ref="commentForm" :model ="formData" :rules="rules" action="http://127.0.0.1:3000/comments/save" method="post">
                  <el-row >
                    <el-col :span=12>
                      <el-form-item prop="userName">
                        <el-input v-model="formData.userName" placeholder="请输入您的姓名"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span=12>
                      <el-form-item prop="userEmail">
                        <el-input v-model="formData.userEmail" placeholder="请输入您的邮箱"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span=24>
                      <el-form-item prop="userSubject">
                        <el-input v-model="formData.userSubject" placeholder="请输入您的专业"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span=24>
                      <el-form-item prop="userDesc">
                        <el-input v-model="formData.userDesc" type="textarea" rows="10" placeholder="请输入您的留言" style="font-family: 微软雅黑"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span=24>
                        <el-button type="primary" class="btn famie-btn" style="margin: 20px 0 5px 0%" @click="submitData">确定发送</el-button>
                        <el-button type="primary" >取消发送</el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-col>

          <!-- Contact Maps -->
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <div class="contact-maps mb-100">
              <iframe src="static/baidu.htm"
                      allowfullscreen></iframe>
            </div>
          </el-col>
        </el-row>
    </section>
    <!-- ##### Contact Area End ##### -->
    <section class="contact">
      <div class="cta">
        <div class="cta_background parallax-window" >
          <el-row>
            <el-col>
              <div class="cta_content text-center">
                <h2>需要做健康咨询, 请联系Bioenergy®中国</h2>
                <!-- <p style="color: cornsilk">亚健康咨询，身体健康评估，慢性病调理，让身体重新恢复活力，请垂询</p> -->
                <el-row :gutter=20 type="flex" justify="center" style="text-align: left;padding-left: 5%">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <div>
                      <h3>公司：苏州西姆提纳米科技有限公司</h3>
                      <h3>地址：寰庆路908号信息港大厦403室</h3>
                      <h3>电话：0512-57070808</h3>
                      <h3>联系人：娄晶</h3>
                      <h3>邮箱：cmt_healthywater@163.com</h3>
                      <h3>抖音：CMT_2020</h3>
                    </div>
                  </el-col>
                  <!--
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="hidden-md-and-down">
                    <div ><img src="../assets/images/addr.png" height="320px" /></div>
                  </el-col>
                  -->
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data () {
    return {
      formData: {
        userName: '',
        userEmail: '',
        userSubject: '',
        userDesc: ''
      },
      rules: {
        userName: [
          {
            required: true, message: '请输入姓名！', trigger: 'blur'
          }
        ],
        userEmail: [
          {
            required: true, message: '请输入邮箱！', trigger: 'blur'
          },
          {
            type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change']
          }
        ],
        userDesc: [
          {
            required: true, message: '请输入您的宝贵意见！', trigger: 'blur'}
        ]
      }
    }
  },

  methods: {
    submitData () {
      //  this.$refs.commentForm.submit()
      // console.log(this.formData)
      this.$refs.commentForm.validate((valid) => {
        if (valid) {
          this.axios.post('http://119.45.63.83:3000/comments/save', this.formData).then((res) => {
            console.log(res)
            this.$refs.commentForm.resetFields()
          })
        }
      })
    }
  }
}
</script>

<style scoped>
 .section-heading {
    position: relative;
    z-index: 1;
    margin-left: 0%;
    margin-bottom: 50px; }
  .section-heading p {
    font-size: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 0; }
  .section-heading h2 {
    margin-bottom: 10px;
    font-size: 36px;
    margin-left: -3px; }
 /* @media only screen and (min-width: 992px) and (max-width: 1199px) {
    .section-heading h2 {
      font-size: 30px; } }
  @media only screen and (min-width: 768px) and (max-width: 991px) {
    .section-heading h2 {
      font-size: 30px; } }
  .section-heading h2 span {
    color: #77b122; }
  @media only screen and (max-width: 767px) {
    .section-heading h2 {
      font-size: 24px; } }
  .section-heading.white h2,
  .section-heading.white p {
    color: #ffffff; }
  .section-heading.white h2 span,
  .section-heading.white p span {
    color: #ffffff; }*/
 .contact-maps {
   position: relative;
   margin-top: 40px;
   z-index: 1;
   width: 100%;
   height: 480px; }
 @media only screen and (max-width: 767px) {
   .contact-maps {
     height: 260px; } }
 .contact-maps iframe {
   width: 100%;
   height: 100%;
   border: none !important; }

 .cta
 {
 //position: relative;
   width: 100%;
 //padding-top: 70px;
 //padding-bottom: 116px;
 //height: 500px;
 }
 .cta_background
 {
 //position: relative;
 //top: 0;
 //left: 0;
   background: url("../assets/images/cta.jpg");
   background-size: cover;
   width: 100%;
   height: 500px;
 }
 .cta_content
 {
   max-width: 768px;
   margin-left: auto;
   margin-right: auto;
 }
 .cta_content h2
 {
   font-size: 48px;
   font-weight: 700;
   color: #FFFFFF;
 }
 .cta_content h3
 {
 //font-size: 48px;
   font-weight: 700;
   color: #FFFFFF;
 }
 .cta_content p
 {
   font-size: 14px;
   font-weight: 500;
   color: #FFFFFF;
   margin-top: -3px;
 }

 textarea::-webkit-input-placeholder{
   color: #999999;
   font-size: 14px;
   font-family:"微软雅黑";
 }

</style>



// WEBPACK FOOTER //
// src/components/contact.vue